import { Component, defineAsyncComponent } from "vue";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function handleAsyncComponent(loader: () => Promise<any>, fallbackComponent?: Component) {
  return defineAsyncComponent({
    loader: () =>
      loader().catch((err: Error) => {
        console.error(`Failed to load component:`, err);
        return fallbackComponent;
      }),
  });
}
